import React, { Component } from 'react';
import BlockRcmAddToCartButton from './BlockRcmAddToCartButton';
import { BlockComponentProps } from 'client-react-block-renderer';
import { getCheckoutOrderManager } from 'cart-ui';
import { CartOrderItem, CartSkuOption } from 'cart-core';
import { GtagCartUpdateMethod } from 'google-analytics/src';

interface Props extends BlockComponentProps<Data, Config> { }

interface Config { }

interface Data {
    showPrice: boolean;
    showBvPv: boolean;
}
interface State {
    addedToCart: boolean;
    networkErrorOccurred: boolean;
    loading: boolean;
}

export default class BlockRcmAddToCartButtonContainer extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.handleSkuSelected = this.handleSkuSelected.bind(this);
        this.state = { addedToCart: false, networkErrorOccurred: false, loading: false };
    }

    private async handleAddToCart(items: CartOrderItem[]) {
        this.setState({ networkErrorOccurred: false, addedToCart: false, loading: true });

        const orderMgr = await getCheckoutOrderManager();
        try {
            await orderMgr.addItems(items, {
                cart_update_method: GtagCartUpdateMethod.PRODUCT_DETAILS_PAGE,
            });
            orderMgr.redirectToCart();
        } catch (error) {
            // tslint:disable-next-line:no-console
            console.error(error);
            this.setState({ networkErrorOccurred: true, loading: false });
        }
    }

    public handleSkuSelected(sku: CartSkuOption) {
        // Inform other blocks (such as the product image block) that a sku was selected
        document.getElementsByTagName('body')[0].dispatchEvent(
            new CustomEvent(
                'BlockRcmAddToCartButton-skuSelected',
                { detail: { skuNumber: sku.skuNumber } }
            )
        );
    }

    public shouldShowTextField(skuOptions: any[]) {
        // if we want to use the text field on other items we can add their item codes here
        const acceptedItemCodes = ['KFCSH', 'KFCAN'];
        for (let i = 0; i < acceptedItemCodes.length; i++) {
            if (skuOptions[0].skuNumber === acceptedItemCodes[i]) {
                return true;
            }
        }
        return false;
    }

    public render() {
        if (this.props.data === null) {
            return <div className="alert alert-warning">
                <strong>Please save the page once to make this block visible and editable.</strong>
                <div>This is needed because this block uses the "data provider" feature and the CMS core is
                not currently able to instantly drag-drop-render blocks that use this feature.
                </div>
            </div>;
        }
        // @ts-ignore
        const skuOptions = window.pageProductV2.activeSkuOptionsAsSortedArray;
        const showTextField = this.shouldShowTextField(skuOptions);

        return <BlockRcmAddToCartButton
            showTextField={showTextField}
            skuOptions={skuOptions}
            onAddToCart={this.handleAddToCart}
            onSkuSelected={this.handleSkuSelected}
            showPrice={this.props.data.showPrice}
            showBvPv={this.props.data.showBvPv}
        />;
    }
}
